import type { Board } from 'jsxgraph';
import type { JsxgraphThemeService } from '../jsxgraph-theme.service';
import type { InteractionFeatureConfig, JsxgraphBoardOptions, JsxgraphStatic } from '../jsxgraph.model';
import { DEFAULT_BOARD_OPTIONS, DEFAULT_INTERACTION_CONFIG, normalizeConfig } from '../jsxgraph.model';

export interface BoardInitOptions {
  container: HTMLElement;
  widgetId: string;
  jsxInstance: JsxgraphStatic;
  themeService: JsxgraphThemeService;
  options?: JsxgraphBoardOptions;
  interaction?: InteractionFeatureConfig | boolean;
  backgroundColor?: string;
}

export function initBoard(opts: BoardInitOptions): Board {
  const { container, widgetId, jsxInstance, themeService, options = {}, interaction, backgroundColor } = opts;

  const containerId = `jsx-${widgetId}-${Date.now()}`;
  container.id = containerId;

  const theme = themeService.getTheme();

  // Apply background color only - border/radius handled by widget wrapper
  container.style.backgroundColor = backgroundColor || theme.colors.background;

  // Apply interaction config
  const interactionConfig = normalizeConfig(interaction, DEFAULT_INTERACTION_CONFIG);
  const interactionOptions: JsxgraphBoardOptions = interactionConfig.enabled
    ? {
        pan: { enabled: interactionConfig.pannable ?? true },
        zoom: interactionConfig.zoomable ?? true,
      }
    : {
        pan: { enabled: false },
        zoom: false,
      };

  const boardOptions: JsxgraphBoardOptions = {
    ...DEFAULT_BOARD_OPTIONS,
    ...interactionOptions,
    ...options,
  };

  return jsxInstance.JSXGraph.initBoard(containerId, boardOptions);
}

export function freeBoard(board: Board, jsxInstance: JsxgraphStatic): void {
  try {
    jsxInstance.JSXGraph.freeBoard(board);
  } catch (error) {
    console.error('Error freeing JSXGraph board:', error);
  }
}
